/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';

import { StyledDialog, Content } from './styles';

const phoneStyles = {
  fontWeight: 'bold',
  margin: '20px 0',
  textAlign: 'center',
  color: '#4C556C',
};

// Modal de Código não recebido
const MissingCodeModal = ({
  retry,
  onClose,
  phone, open,
}) => (
  <StyledDialog
    open={open}
    onClose={onClose}
  >
    <Content>
      <IconButton
        color="secondary"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Title>Não recebeu o código?</Title>
      <Text>
        Verifique se digitou o número do celular corretamente.
      </Text>
      <Text style={phoneStyles}>
        {phone}
      </Text>
      <Button
        onClick={retry}
      >
        Reeviar código
      </Button>
      <Button
        onClick={onClose}
        variant="outlined"
        style={{ border: 0 }}
      >
        Alterar número de celular
      </Button>
    </Content>
  </StyledDialog>
);

MissingCodeModal.propTypes = {
  retry: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default MissingCodeModal;
